import React from "react";
var GroupHeader = function GroupHeader(_ref) {
  var _item$link;
  var item = _ref.item,
    handleGroupOnHeaderClick = _ref.handleGroupOnHeaderClick,
    showGroupItems = _ref.showGroupItems,
    groupIndex = _ref.groupIndex;
  return /*#__PURE__*/React.createElement("button", {
    id: "footer-group-header-".concat(groupIndex + 1),
    className: "footer__group__mobile-header",
    onClick: function onClick(e) {
      handleGroupOnHeaderClick(e);
    },
    dangerouslySetInnerHTML: {
      __html: ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.content) || item.html.html
    },
    type: "button",
    "aria-expanded": showGroupItems,
    "aria-controls": "footer-group-items-".concat(groupIndex + 1)
  });
};
export default GroupHeader;